// extracted by mini-css-extract-plugin
export default {"fractional-quantity":"FractionalQuantity-module__fractional-quantity___1IPsR"};